@switch (displayMode) {
  @case ('wrapped') {
    <mat-accordion>
      <mat-expansion-panel
        (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)"
        [expanded]="isExpanded"
        togglePosition="before"
        class="border-2">
        <mat-expansion-panel-header class="min-h-[100px] bg-brandLightBlueFill dark:bg-gray-700">
          <div class="flex flex-row justify-between items-center w-full">
            <div class="flex flex-col">
              <span class="font-bold text-xl dark:text-white">{{ item?.quote_request_bond?.company_name }}</span>
              @if (item?.company_dba) {
                <span class="font-semibold text-md">DBA: {{ item?.company_dba }}</span>
              }
              <span class="font-medium text-sm text-gray-400 dark:text-gray-400">
                {{ item?.quote_request_bond?.state_abbreviation }} - {{ item?.quote_request_bond?.surety_bond_label }}
                @if (item?.selected_quote?.bond_effective_date) {
                  | Effective Date: {{ item?.selected_quote?.bond_effective_date ?? '' | date: 'shortDate' }}
                }
              </span>
            </div>
            <div class="flex flex-col align-right text-right">
              <p class="text-lg font-bold" *ngIf="item?.selected_quote?.premium">
                {{ item?.selected_quote?.premium | currency: 'USD' }}
              </p>

              <p class="accent-green-500 text-sm text-primary" *ngIf="item?.selected_quote?.duration">
                {{ getDurationTerm(item) }}
              </p>
            </div>
          </div>
        </mat-expansion-panel-header>
        <div class="rounded-lg px-2">
          <div class="w-full flex flex-col justify-between pt-4">
            <!--Bond Details-->
            <div class="flex flex-row justify-between">
              <span class="font-semibold text-lg my-4">Bond Details</span>
              @if (menuItems.length > 0) {
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
              }
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  *ngFor="let _item of menuItems"
                  [disabled]="!_item.enabled"
                  (click)="onMenuClick(_item)">
                  <mat-icon *ngIf="_item.icon">{{ _item.icon }}</mat-icon>
                  <span>{{ _item.label }}</span>
                </button>
              </mat-menu>
            </div>
            <div class="grid grid-cols-2 gap-4">
              <!-- License Number -->
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-white">Order Number</p>
                <p class="text-md font-semibold text-green-500">{{ item?.order_number }}</p>
              </div>

              <!-- Date Ordered -->
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-white">Date Requested</p>
                <p class="text-md font-semibold text-gray-500">{{ item?.quote_request_date | date: 'MM/dd/yyyy' }}</p>
              </div>

              <!-- Company Type -->
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-white">Company Type</p>
                <p class="text-md font-semibold text-gray-500">{{ item?.quote_request_bond?.company_type_label }}</p>
              </div>

              <!-- Principal Address -->
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-white">Principal Address</p>
                <p class="text-md font-semibold text-gray-500">{{ getFormattedAddress(item?.principal_address) }}</p>
              </div>

              @if (!item?.is_managed) {
                <div
                  class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 w-full"
                  role="alert">
                  <span class="block sm:inline">
                    Warning: This quote request is not managed. Do not disclose any information to Account Members.
                  </span>
                </div>
              }

              <div class="col-span-2">
                <div
                  class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4 w-full"
                  role="alert">
                  <span class="block sm:inline">
                    <mat-icon
                      [svgIcon]="item.is_managed ? 'heroicons_outline:lock-open' : 'heroicons_outline:lock-closed'"
                      [matTooltip]="item.is_managed ? 'Managed' : 'Unmanaged'"
                      [color]="item.is_managed ? 'primary' : 'warn'"></mat-icon>

                    @if (item.is_managed) {
                      This quote request is managed by
                      {{
                        item?.account_user_details?.account_user_first_name +
                          ' ' +
                          item?.account_user_details?.account_user_last_name
                      }}.
                    } @else {
                      This quote request is not managed by the Account and
                      {{
                        item?.account_user_details?.account_user_first_name +
                          ' ' +
                          item?.account_user_details?.account_user_last_name
                      }}
                    }
                  </span>
                </div>
              </div>

              @if (item?.is_user_silent) {
                <div class="col-span-2">
                  <div
                    class="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative mb-4 w-full"
                    role="alert">
                    <span class="block sm:inline">This request is for {{ item?.account_user_name }} themself</span>
                  </div>
                </div>
              }
            </div>
            <mat-divider class="my-4"></mat-divider>

            <!--Bond Owner-->
            <span class="font-semibold text-lg my-4">Bond Owner</span>
            <div class="grid grid-cols-2 gap-4">
              <!-- License Number -->
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-white">Owner</p>
                <p class="text-md font-semibold">{{ item?.user_first_name + ' ' + item?.user_last_name }}</p>
              </div>

              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-white">Contact</p>
                <p class="text-md font-semibold text-gray-500">+{{ item.user_phone }}</p>
              </div>
            </div>
            <mat-divider class="my-4"></mat-divider>

            @if (item?.selected_quote) {
              <!--Quote Options-->
              <span class="font-semibold text-lg my-4">Quote Options</span>
              <div class="rounded-lg overflow-hidden">
                @if (item?.customer_can_purchase == 1) {
                  <form [formGroup]="item?.quote_selection_form">
                    <!--Bond Option Selector-->
                    <mat-radio-group
                      aria-label="Select Bond Term"
                      class="flex flex-col w-full rounded-lg"
                      formControlName="selected_quote_option"
                      (change)="onQuoteChange()">
                      <div class="flex flex-col gap-0 m-1">
                        <div
                          *ngFor="let quoteOption of item?.quote_request_bond.quotes"
                          [ngClass]="{ 'border-2': quoteOption.premium !== item?.selected_quote?.premium }">
                          <div
                            class="flex flex-row w-full rounded-md dark:text-white"
                            [ngClass]="{
                              'selected border-2 border-brandOrange bg-orange-50 dark:bg-brandOrange':
                                quoteOption.premium === item?.selected_quote?.premium,
                              '': +item?.customer_can_purchase !== 0,
                            }">
                            <mat-radio-button [value]="quoteOption.premium" class="pt-1 w-[30px]"></mat-radio-button>
                            <div class="flex flex-col w-full p-3">
                              <div class="flex flex-row justify-between text-md font-semibold">
                                <span>{{ getDurationTerm(quoteOption) }}</span>
                                <div class="flex flex-col justify-end items-end">
                                  <span>{{ quoteOption?.premium | currency: 'USD' }}</span>
                                  <!--                              <span *ngIf="+item?.customer_can_purchase === 0 && quoteOption.premium === item?.selected_quote?.premium" class="badge badge-brandGreen">Selected</span>-->
                                </div>
                              </div>
                              <div class="flex flex-row justify-between text-sm text-gray-400 dark:text-white">
                                <span>
                                  {{ quoteOption?.bond_effective_date ?? '' | date: 'shortDate' }}&nbsp;-&nbsp;{{
                                    quoteOption?.bond_expiration_date | date: 'shortDate'
                                  }}
                                </span>
                                @if (
                                  quoteOption?.collateral !== null &&
                                  !isNaN(+quoteOption?.collateral) &&
                                  +quoteOption?.collateral > 0
                                ) {
                                  <span class="text-red-500 dark:text-black text-sm">
                                    Requires Collateral: {{ quoteOption?.collateral | currency: 'USD' }}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-radio-group>
                  </form>
                } @else {
                  <div class="flex flex-col gap-0 m-1">
                    <div
                      class="flex flex-row w-full rounded-md dark:text-white selected border-2 border-brandOrange bg-orange-50 dark:bg-brandOrange">
                      <mat-radio-button [checked]="true" class="pt-1 w-[30px]" [disabled]="true"></mat-radio-button>
                      <div class="flex flex-col w-full p-3">
                        <div class="flex flex-row justify-between text-md font-semibold">
                          <span>{{ getDurationTerm(item?.selected_quote) }}</span>
                          <div class="flex flex-col justify-end items-end">
                            <span>{{ item?.selected_quote?.premium | currency: 'USD' }}</span>
                          </div>
                        </div>
                        <div class="flex flex-row justify-between text-sm text-gray-400 dark:text-white">
                          <span>
                            {{ item?.selected_quote?.bond_effective_date ?? '' | date: 'shortDate' }}&nbsp;-&nbsp;{{
                              item?.selected_quote?.bond_expiration_date | date: 'shortDate'
                            }}
                          </span>
                          @if (
                            item?.selected_quote?.collateral !== null &&
                            !isNaN(+item?.selected_quote?.collateral) &&
                            +item?.selected_quote?.collateral > 0
                          ) {
                            <span class="text-red-500 dark:text-black text-sm">
                              Requires Collateral: {{ item?.selected_quote?.collateral | currency: 'USD' }}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }

            <!--Bond Delivery-->
            <div class="my-4">
              <span class="font-semibold text-lg">Bond Delivery</span>
              <p class="text-sm text-gray-400 dark:text-white">Delivery Method</p>
              <span class="bg-orange-300 dark:bg-brandOrange dark:text-white px-4 py-1 rounded-md w-fit">
                {{ item?.shipping_details?.shipping_option_label }}
              </span>
            </div>
            <!--Bond Delivery-->

            <div class="my-4" *ngIf="item?.quote_request_bond?.related_files.length > 0">
              <span class="font-semibold text-lg my-4">
                Attached File{{
                  item?.quote_request_bond.related_files.length > 1
                    ? 's (' + item?.quote_request_bond.related_files.length + ')'
                    : ''
                }}
              </span>
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <!--"-->
                <mat-card
                  *ngFor="let file of item?.quote_request_bond?.related_files"
                  (click)="onFileClick(file.file_id)"
                  class="cursor-pointer hover:bg-slate-50"
                  [matTooltip]="file.file_friendly_name">
                  <mat-card-content>
                    <p class="underline truncate" rel="noopener noreferrer flex flex-row items-center">
                      <span class="micon">
                        <mat-icon *ngIf="file.file_extension === 'pdf'" class="mr-2">picture_as_pdf</mat-icon>
                        <mat-icon *ngIf="file.file_extension === 'doc' || file.file_extension === 'docx'" class="mr-2">
                          description
                        </mat-icon>
                        <mat-icon *ngIf="file.file_extension === 'jpg' || file.file_extension === 'png'" class="mr-2">
                          image
                        </mat-icon>
                        <mat-icon
                          *ngIf="!['pdf', 'doc', 'docx', 'jpg', 'png'].includes(file.file_extension)"
                          class="mr-2">
                          insert_drive_file
                        </mat-icon>
                      </span>
                      <b>({{ file.related_file_type_label }})</b>
                      {{ file.file_friendly_name | ellipsis: (isScreenSmall ? 10 : 20) }}
                    </p>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  }
  @case ('full') {
    <div class="rounded-lg px-2">
      <div class="w-full flex flex-col justify-between pt-0">
        <!--Bond Details-->
        <div class="flex flex-row justify-between items-center">
          <span class="font-semibold text-lg my-4">Bond Details</span>
          @if (menuItems.length > 0) {
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngFor="let item of menuItems" [disabled]="!item.enabled" (click)="onMenuClick(item)">
              <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
              <span>{{ item.label }}</span>
            </button>
          </mat-menu>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <!-- License Number -->
          <div>
            <p class="text-sm font-medium text-gray-400 dark:text-white">Order Number</p>
            <p class="text-md font-semibold text-green-500">{{ item?.order_number }}</p>
          </div>

          <!-- Date Ordered -->
          <div>
            <p class="text-sm font-medium text-gray-400 dark:text-white">Date Ordered</p>
            <p class="text-md font-semibold text-gray-500">{{ item?.quote_request_date | date: 'MM/dd/yyyy' }}</p>
          </div>

          <!-- Company Type -->
          <div>
            <p class="text-sm font-medium text-gray-400 dark:text-white">Company Type</p>
            <p class="text-md font-semibold text-gray-500">{{ item?.quote_request_bond?.company_type_label }}</p>
          </div>

          <!-- Principal Address -->
          <div>
            <p class="text-sm font-medium text-gray-400 dark:text-white">Principal Address</p>
            <p class="text-md font-semibold text-gray-500">{{ getFormattedAddress(item?.principal_address) }}</p>
          </div>

          @if (item?.is_managed === false) {
            <div class="col-span-2">
              <div
                class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 w-full flex flex-row items-center gap-4"
                role="alert">
                <mat-icon
                  [svgIcon]="'heroicons_outline:lock-closed'"
                  [matTooltip]="'Unmanaged'"
                  class="icon-size-5"
                  [color]="'warn'"></mat-icon>

                <span class="block sm:inline text-sm">
                  Warning: This quote request is not managed. Do not disclose any information to Account Members.
                </span>
              </div>
            </div>
          } @else {
            <div class="col-span-2">
              <div
                class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4 w-full flex flex-row items-center gap-4"
                role="alert">
                <mat-icon
                  [svgIcon]="'heroicons_outline:lock-open'"
                  [matTooltip]="'Managed'"
                  class="icon-size-5"
                  [color]="'primary'"></mat-icon>
                <span class="block sm:inline text-sm">
                  This quote request is managed by the Account and
                  {{
                    item?.account_user_details?.account_user_first_name +
                      ' ' +
                      item?.account_user_details?.account_user_last_name
                  }}.
                  @if (item?.is_silent_user) {
                    This request is for
                    {{
                      item?.account_user_details?.account_user_first_name +
                        ' ' +
                        item?.account_user_details?.account_user_last_name
                    }}
                    themself.
                  }
                </span>
              </div>
            </div>
          }
        </div>
        <mat-divider class="my-4"></mat-divider>

        <!--Bond Owner-->
        <span class="font-semibold text-lg my-4">Bond Owner</span>
        <div class="grid grid-cols-2 gap-4">
          <!-- License Number -->
          <div>
            <p class="text-sm font-medium text-gray-400 dark:text-white">Owner</p>
            <p class="text-md font-semibold">{{ item?.user_first_name + ' ' + item?.user_last_name }}</p>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-400 dark:text-white">Contact</p>
            <p class="text-md font-semibold text-gray-500">{{ item?.user_phone }}</p>
          </div>
        </div>
        <mat-divider class="my-4"></mat-divider>

        @if (item?.selected_quote) {
          <!--Quote Options-->
          <span class="font-semibold text-lg my-4">Quote Options</span>
          <div class="rounded-lg overflow-hidden">
            @if (item?.customer_can_purchase == 1) {
              <form [formGroup]="item?.quote_selection_form">
                <!--Bond Option Selector-->
                <mat-radio-group
                  aria-label="Select Bond Term"
                  class="flex flex-col w-full rounded-lg"
                  formControlName="selected_quote_option"
                  (change)="onQuoteChange()">
                  <div class="flex flex-col gap-0 m-1">
                    <div
                      *ngFor="let quoteOption of item?.quote_request_bond.quotes"
                      [ngClass]="{ 'border-2': quoteOption.premium !== item?.selected_quote?.premium }">
                      <div
                        class="flex flex-row w-full rounded-md dark:text-white"
                        [ngClass]="{
                          'selected border-2 border-brandOrange bg-orange-50 dark:bg-brandOrange':
                            quoteOption.premium === item?.selected_quote?.premium,
                          '': +item?.customer_can_purchase !== 0,
                        }">
                        <mat-radio-button [value]="quoteOption.premium" class="pt-1 w-[30px]"></mat-radio-button>
                        <div class="flex flex-col w-full p-3">
                          <div class="flex flex-row justify-between text-md font-semibold">
                            <span>{{ getDurationTerm(quoteOption) }}</span>
                            <div class="flex flex-col justify-end items-end">
                              <span>{{ quoteOption?.premium | currency: 'USD' }}</span>
                              <!--                              <span *ngIf="+item?.customer_can_purchase === 0 && quoteOption.premium === item?.selected_quote?.premium" class="badge badge-brandGreen">Selected</span>-->
                            </div>
                          </div>
                          <div class="flex flex-row justify-between text-sm text-gray-400 dark:text-white">
                            <span>
                              {{ quoteOption?.bond_effective_date ?? '' | date: 'shortDate' }}&nbsp;-&nbsp;{{
                                quoteOption?.bond_expiration_date | date: 'shortDate'
                              }}
                            </span>
                            @if (
                              quoteOption?.collateral !== null &&
                              !isNaN(+quoteOption?.collateral) &&
                              +quoteOption?.collateral > 0
                            ) {
                              <span class="text-red-500 dark:text-black text-sm">
                                Requires Collateral: {{ quoteOption?.collateral | currency: 'USD' }}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-radio-group>
              </form>
            } @else {
              <div class="flex flex-col gap-0 m-1">
                <div
                  class="flex flex-row w-full rounded-md dark:text-white selected border-2 border-brandOrange bg-orange-50 dark:bg-brandOrange">
                  <mat-radio-button [checked]="true" class="pt-1 w-[30px]" [disabled]="true"></mat-radio-button>
                  <div class="flex flex-col w-full p-3">
                    <div class="flex flex-row justify-between text-md font-semibold">
                      <span>{{ getDurationTerm(item?.selected_quote) }}</span>
                      <div class="flex flex-col justify-end items-end">
                        <span>{{ item?.selected_quote?.premium | currency: 'USD' }}</span>
                      </div>
                    </div>
                    <div class="flex flex-row justify-between text-sm text-gray-400 dark:text-white">
                      <span>
                        {{ item?.selected_quote?.bond_effective_date ?? '' | date: 'shortDate' }}&nbsp;-&nbsp;{{
                          item?.selected_quote?.bond_expiration_date | date: 'shortDate'
                        }}
                      </span>
                      @if (
                        item?.selected_quote?.collateral !== null &&
                        !isNaN(+item?.selected_quote?.collateral) &&
                        +item?.selected_quote?.collateral > 0
                      ) {
                        <span class="text-red-500 dark:text-black text-sm">
                          Requires Collateral: {{ item?.selected_quote?.collateral | currency: 'USD' }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <!--Bond Delivery-->
        <span class="font-semibold text-lg my-4">Bond Delivery</span>
        <p class="text-sm text-gray-400 dark:text-white">Delivery Method</p>
        <span class="bg-orange-300 dark:bg-brandOrange dark:text-white px-4 py-1 rounded-md w-fit">
          {{ item?.shipping_details?.shipping_option_label }}
        </span>
      </div>
    </div>
  }
}
